// IE9,10,11
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import "./styles.css";

import { Title } from "./components/organisms/Title";
import { Header } from "./components/organisms/Header";
import { RenderTimeTable } from "./components/organisms/RenderTimeTable";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: true,
      refetchOnWindowFocus: false
    }
  }
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <Title />
        <Header />
        <RenderTimeTable />
      </div>
    </QueryClientProvider>
  );
}
